/**
 * Export
 */
export const SET_LANGUAGE = 'SET_LANGUAGE'

export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAILED = 'LOGIN_FAILED'